import { pick, prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { languageService } from 'js/services/language.service';
import { useGetTemporaryAuthenticationToken } from 'js/hooks/auth';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';

import * as actions from '../../../store/actions';
import { useIsWidgetsEnabled } from './useIsWidgetsEnabled';

export const useLogin = () => {
    const { isLoggedIn, lang, userName } = useUserSelector(pick(['lang', 'isLoggedIn', 'userName']));
    const { casinoName, clientType, clientVersion } = useAppSelector(
        pick(['casinoName', 'clientType', 'clientVersion']));
    const getTemporaryAuthenticationToken = useGetTemporaryAuthenticationToken();
    const { enableInbox } = useIsWidgetsEnabled();
    const dispatch = useDispatch();
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));

    return useCallback(() => {
        if (!isLoggedIn || !window.Communication) {
            return;
        }

        (async () => {
            const temporaryToken = await getTemporaryAuthenticationToken();

            await window.Communication.API.common.loginByToken({
                userName,
                casinoName,
                clientType,
                clientVersion,
                realMode: 1,
                sessionToken: temporaryToken,
                languageCode: languageService.convertToIMS(lang),
                clientPlatform,
                deliveryPlatform: 'Hub2'
            });

            enableInbox && await window.Communication.API.inbox.subscribe();
            dispatch(actions.setIsWidgetsAuthenticated(true));
        })();
    }, [
        isLoggedIn, lang, userName,
        casinoName, clientType, clientVersion, enableInbox,
        getTemporaryAuthenticationToken, clientPlatform, dispatch
    ]);
};
